import { FC } from "react"

import ManufacturerContactAndSafetyInfo from "../manufacturerContactAndSafetyInfo";

import { ManufacturerSubHeader } from "./types";
import { TextAlignProps } from "../../contactAndSafetyInfo/types";



const AuthMaunfacturerSubHeader: FC<ManufacturerSubHeader> = ({ user, territory }): JSX.Element => {
  return (
    <div className="row align-items-center">
      <div className="col-12 col-lg-3 text-left">
        {!(window.location.href.includes("doctor") || window.location.href.includes("practice")) && (
          <div className="row">
            <p className="text-dark fw-bold">
              User: <span className="fw-lighter">{user || territory ? user : "National"}</span>
            </p>
            <p className="text-dark fw-bold ">
              Territory: <span className="fw-lighter">{user || territory ? territory : "National"}</span>
            </p>
          </div>
        )}
      </div>

      <div className="col-12 col-lg-3 text-center">
        <div className="col-12 col-md-3 text-left"></div>
      </div>

      <div className="col-12 col-lg-6">
        <ManufacturerContactAndSafetyInfo textColor="primary" alignText={TextAlignProps.TEXT_END} />
      </div>
    </div>
  );
};

export default AuthMaunfacturerSubHeader;
